import isEmpty from 'lodash/isEmpty';

export type MultipleSelectFieldOption = {
	value: string;
	id: string;
}[];

export const getMultipleSelectFieldValue = ({
	defaultValue,
	allowedValues,
}: {
	defaultValue: unknown;
	allowedValues: unknown;
}): MultipleSelectFieldOption | null => {
	const values: MultipleSelectFieldOption = [];
	if (
		Array.isArray(defaultValue) &&
		defaultValue.every((item) => typeof item === 'string') &&
		Array.isArray(allowedValues)
	) {
		for (const defaultValues of defaultValue) {
			for (const isValue of allowedValues) {
				if (isValue.id === defaultValues) {
					values.push({
						value: isValue.value,
						id: isValue.id,
					});
				}
			}
		}
		return isEmpty(values) ? null : values;
	}
	return null;
};
